import { render, staticRenderFns } from "./TheIndicatorDatasoureComparisonChart.vue?vue&type=template&id=681eb5b9&scoped=true&"
import script from "./TheIndicatorDatasoureComparisonChart.vue?vue&type=script&lang=js&"
export * from "./TheIndicatorDatasoureComparisonChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681eb5b9",
  null
  
)

export default component.exports